import {chain} from 'lodash';

import {
  ApplicationPaginationToken,
  ApplicationTagList,
} from '../../../applications/bridge/v2/types/bridgeTypesV2';
import {serializeTagAndParentsForApplication} from '../../../helpers/models/applicationSerializationHelpers';
import {buildTagSearchUrl} from '../../../helpers/models/tagHelpers';
import {ApiSearchTags} from '../../../models/api/searchTagModel';
import {TagBehaviorsEnum} from '../../../models/api/tagModel';
import {
  buildApplicationPaginationToken,
  tryParseApplicationPaginationToken,
} from '../../../models/applications/applicationPaginationTokenTypes';
import {fetchApiAsync} from '../../../services/http/http';
import {ThunkAsyncAction} from '../../appThunk';
import {getCompany} from '../company/companySelectors';

const tagsPaginationLimit = 50;

/*
 * Actions.
 */

export function applicationListTagsAsyncAction(
  paginationToken?: ApplicationPaginationToken,
): ThunkAsyncAction<ApplicationTagList> {
  return async (_dispatch, getState) => {
    // Parse the pagination token, if any.
    const pagination = tryParseApplicationPaginationToken(paginationToken);
    const offset = pagination?.offset || 0;

    // Fetch one more than the request amount.
    // If there are more than the requested amount, there are additional records.
    const company = getCompany(getState());
    const tagSearchUrl = buildTagSearchUrl(company, '', {
      offset,
      limit: tagsPaginationLimit + 1,
      behaviors: [TagBehaviorsEnum.CAN_APPLY_FROM_LIST],
    });

    const {tags} = await fetchApiAsync(ApiSearchTags, tagSearchUrl);

    const nextPageToken =
      tags.length > tagsPaginationLimit
        ? buildApplicationPaginationToken({offset: offset + tagsPaginationLimit})
        : undefined;

    const results = chain(tags)
      .take(tagsPaginationLimit)
      .map((tagChain) => serializeTagAndParentsForApplication(tagChain[0], tagChain.slice(1)))
      .compact()
      .value();

    return {nextPageToken, results};
  };
}
